"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const Div_1 = require("./Div");
const Text_1 = require("./Text");
const color_1 = require("../constants/color");
const theme_1 = require("../constants/theme");
const create_styles_1 = require("../utils/create-styles");
const VALUES = {
    xs: {
        button: 12,
        switchHeight: 15,
        switchWidth: 30,
        translate: 16.5,
    },
    lg: {
        button: 22,
        switchHeight: 25,
        switchWidth: 50,
        translate: 25.5,
    },
};
const Body = styled_1.default.div({
    alignItems: 'center',
    display: 'flex',
    gap: 8,
});
const Button = styled_1.default.span((props) => ({
    background: color_1.Color.WHITE,
    borderRadius: 999,
    boxShadow: theme_1.theme.boxShadow.normal,
    content: '""',
    height: VALUES[props.size].button,
    left: 0,
    position: 'absolute',
    transform: `translate(${props.checked ? VALUES[props.size].translate : 1.5}px, 1.5px)`,
    transition: theme_1.theme.animation.transition,
    width: VALUES[props.size].button,
}));
const Checkbox = styled_1.default.input({
    height: 0,
    visibility: 'hidden',
    width: 0,
});
const Label = styled_1.default.label((props) => ({
    color: props.design === 'blue' ? color_1.Color.BLUE : color_1.Color.DARK_GREY,
    cursor: 'pointer',
    fontSize: props.labelSize === 'small' ? theme_1.theme.font.size[6] : theme_1.theme.font.size[5.5],
    fontWeight: props.labelSize === 'small'
        ? theme_1.theme.font.weight.medium
        : props.design === 'blue'
            ? theme_1.theme.font.weight.bold
            : 'grey',
}));
const Switch = styled_1.default.label((props) => ({
    backgroundColor: props.disabled
        ? color_1.Color.LIGHT_GREY
        : props.checked
            ? color_1.Color.BLUE
            : color_1.Color.GREY,
    borderRadius: 999,
    cursor: props.disabled ? 'not-allowed' : 'pointer',
    height: VALUES[props.size].switchHeight,
    position: 'relative',
    transition: `background-color ${theme_1.theme.animation.transition}`,
    width: VALUES[props.size].switchWidth,
}));
const SwitchLabel = styled_1.default.label({
    cursor: 'pointer',
    userSelect: 'none',
});
const ToggleElement = styled_1.default.div((props) => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: props.direction,
    gap: 12,
    justifyContent: props.compact ? 'flex-start' : 'space-between',
    userSelect: 'none',
    ...(0, create_styles_1.createStyles)(props.styles),
}));
const Toggle = ({ size = 'lg', labelDesign = 'blue', ...props }) => {
    const id = (0, react_1.useId)();
    return ((0, jsx_runtime_1.jsxs)(ToggleElement, { compact: props.compact, direction: props.direction ?? 'column', styles: props.styles, children: [(props.label || props.subtitle) && ((0, jsx_runtime_1.jsxs)(Div_1.Div, { styles: { flex: 'col', gap: 1 }, children: [props.label && ((0, jsx_runtime_1.jsx)(Label, { htmlFor: id, labelSize: props.labelSize, design: labelDesign, children: props.label })), props.subtitle && ((0, jsx_runtime_1.jsx)(Text_1.Text, { color: color_1.Color.DARK_GREY, size: props.labelSize === 'small' ? 6.5 : 6, children: props.subtitle }))] })), (0, jsx_runtime_1.jsxs)(Body, { children: [props.uncheckedLabel && ((0, jsx_runtime_1.jsx)(SwitchLabel, { htmlFor: id, children: props.uncheckedLabel })), (0, jsx_runtime_1.jsxs)(Switch, { checked: props.checked, disabled: props.disabled, size: size, children: [(0, jsx_runtime_1.jsx)(Checkbox, { checked: props.checked, disabled: props.disabled, id: id, onChange: (event) => {
                                    props.onChange?.(event);
                                    props.onCheckedChange(event.target.checked);
                                }, type: "checkbox" }), (0, jsx_runtime_1.jsx)(Button, { checked: props.checked, size: size })] }), props.checkedLabel && ((0, jsx_runtime_1.jsx)(SwitchLabel, { htmlFor: id, children: props.checkedLabel }))] })] }));
};
exports.Toggle = Toggle;
